import React, { Fragment, useEffect, useState, Component } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';
import {render} from 'react-dom';

import Session from './components/session';

import Home from './pages/home';
import Login from './pages/login';
import Confirm from './pages/student_confirm';
import Finalize from './pages/student_finalize';
import Guard from './components/guard';
import GuardConfirm from './components/guard_confirm';
import GuardAttend from './components/guard_attend';
import TopBar from './components/topbar';
import ErrorPage from './components/ErrorPage';
import Manual from './pages/manual';
import Attend from './pages/attend';
import AttendConfirm from './pages/attend_confirm';

import CircleProgressIndicator from './components/circle_progress_indicator';
import { APIError } from './api';
import {Toaster} from './toast';

import auth from './auth';
import Styles from './styles';
import config from './config';
import { ShutdownProvider } from './shutdown';
import Preview from './preview';

const {base} = config;

const main = () => {
  render(
    <Router basename={base}>
      <Styles/>
      <Catch>
        <Toaster>
          <ShutdownProvider>
            <Session>
              <App/>
            </Session>
          </ShutdownProvider>
        </Toaster>
      </Catch>
    </Router>,
    document.getElementById('mount'));
};

const App = () => {
  return (
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route path="/preview" component={Preview}/>
      <Guard>
        <Signed/>
      </Guard>
    </Switch>
  );
};

const Signed = () => {
  return (
    <Switch>
      <Route exact path="/student/confirm" component={Confirm} />
      <Route exact path="/student/finalize/:passcode" component={Finalize} />
      <Route>
        <GuardConfirm>
          <Confirmed/>
        </GuardConfirm>
      </Route>
    </Switch>
  );
};

const Confirmed = () => {
  return (
    <Switch>
      <Route exact path="/attend/:subject_number/confirm" component={AttendConfirm} />
      <Route exact path="/attend/:subject_number">
        <GuardAttend>
          <Attend/>
        </GuardAttend>
      </Route>
      <Route>
        <TopBar/>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/manual" component={Manual} />
          <Route>
            <ErrorPage message="存在しないページです"/>
          </Route>
        </Switch>
      </Route>
    </Switch>
  );
};

class Catch extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error) {
    return {error};
  }

  componentDidCatch(error, errorInfo) {
    if (error instanceof APIError && error.code == 401) {
      this.setState({error: null});
      alert('セッションが切断しました。再度ログインし直してください');
      location.href = `${base}/login`;
    }
    console.error(error);
    console.error(errorInfo);
  }

  render() {
    const {children} = this.props;
    const {error} = this.state;
    return error ? <ErrorPage message={'予期せぬエラーが発生しました'} /> : children;
  }
}

main();

if (module.hot) {
  module.hot.accept();
}
